import theme from "../../utils/theme";

const brand = theme.palette.brand;

export const COLORS = {
  primary: brand.primary,
  secondary: brand.secondary,
  success: brand.success,
  edit: brand.primary,
  delete: "#f44336",
};

export const editButtonSx = {
  background: COLORS.edit,
  color: "#fff",
  width: 76,
  height: 32,
  textTransform: "none" as const,
  "&:hover": {
    bgcolor: COLORS.edit,
    opacity: 0.9,
  },
};

export const deleteButtonSx = {
  background: COLORS.delete,
  color: "#fff",
  width: 76,
  height: 32,
  marginLeft: "8px",
  textTransform: "none" as const,
  "&:hover": {
    bgcolor: COLORS.delete,
    opacity: 0.9,
  },
};

export const addButtonSx = {
  background: COLORS.success,
  color: "#fff",
  textTransform: "none" as const,
  "&:hover": {
    bgcolor: COLORS.success,
    opacity: 0.9,
  },
};

export const permissionsButtonSx = {
  borderColor: COLORS.primary,
  color: COLORS.primary,
  width: 120,
  height: 32,
  textTransform: "none" as const,
};
